var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.999,
    height: 17.999,
    viewBox: "0 0 17.999 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13962",
    "data-name": "Group 13962",
    transform: "translate(-1200 -1023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pen-alt",
    d: "M17.494,2.6,15.381.492a1.688,1.688,0,0,0-2.387,0L11.006,2.48l4.5,4.5,1.988-1.988A1.688,1.688,0,0,0,17.494,2.6ZM8.818,1.883a1.406,1.406,0,0,0-1.988,0L2.654,6.059a.562.562,0,0,0,0,.8l.8.8a.562.562,0,0,0,.8,0L7.825,4.071l.8.8L3.292,10.193A11.5,11.5,0,0,0,0,17.051v.008a.844.844,0,0,0,.931.932,11.5,11.5,0,0,0,6.867-3.3l6.918-6.918L11.8,4.866,8.818,1.883Z",
    transform: "translate(1200.011 1023.003)",
    fill: "#1492e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_63",
    "data-name": "Line 63",
    d: "M10,.718H-.064A.711.711,0,0,1-.75-.016.711.711,0,0,1-.064-.75H10a.711.711,0,0,1,.686.734A.711.711,0,0,1,10,.718Z",
    transform: "translate(1207.311 1040.282)",
    fill: "#1492e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEdit);
export default __webpack_public_path__ + "static/media/profile-edit.9dbc21a278da596fe0eab2adc94fb5ba.svg";
export { ForwardRef as ReactComponent };